import { gql } from "graphql-request"
import { ServiceGraphql } from "./Graphql"

export const graphOnUsTransfer = async (contractId, targetSearchMethod, targetIdentifierNumber, message, amount, otp) => {
  const ON_US_TRANSFER = gql`
  mutation OnUsTransfer($amount: Int!, $contractId: Int!, $message: String!, $targetIdentifierNumber: String!, $targetSearchMethod: Way4ContractSearchMethod!) {
    OnUsTransfer(amount: $amount, contractId: $contractId, message: $message, targetIdentifierNumber: $targetIdentifierNumber, targetSearchMethod: $targetSearchMethod) {
      id
      additionalData
      amount
      message
      rrn
      sourceNumber
      status
      targetNumber
      transactionDate
      transactionType
    }
  }
  `

  const variables = {
    "amount": parseInt(amount),
    "contractId": parseInt(contractId),
    "message": message,
    "targetIdentifierNumber": targetIdentifierNumber,
    "targetSearchMethod": targetSearchMethod
  }

  const headers = {
      'x-verify-code': otp,
  }

  const response = await ServiceGraphql.request(ON_US_TRANSFER, variables, headers);
  return response.OnUsTransfer;
}

export const graphGetAllBank = async(variables) => {
  const ALL_BANK = gql`
  query AllBanks($filter: BankFilter, $options: FilterOptions) {
    AllBanks(filter: $filter, options: $options) {
      items {
        id
        bankName
        bankCode
      }
    }
  }
  `

  const response = await ServiceGraphql.request(ALL_BANK, variables);
  return response.AllBanks;
}